import { useRef, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { membershipPlansErrorSelector } from '@hero/redux-data/backoffice/membershipPlans/selectors';
import { useNotifications } from '../../context/notification';
const useMembershipPlansFailAlert = () => {
    const { error, errorMessage } = useSelector(membershipPlansErrorSelector, shallowEqual);
    const { addNotification, removeNotification } = useNotifications();
    const id = useRef();
    useEffect(() => {
        id.current && removeNotification(id.current);
        if (error) {
            id.current = addNotification({
                type: 'fail',
                message: errorMessage || 'Error fetching membership plans.'
            });
        }
        else {
            id.current = undefined;
        }
    }, [addNotification, removeNotification, error, errorMessage]);
};
export default useMembershipPlansFailAlert;
